import type { Quote } from "./types";

// A rate as a fraction of the rent: 0.0149 -> "1,49%".
export const formatRate = (rate: number): string =>
  `${(rate * 100).toLocaleString("es-CO", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  })}%`;

// One formatter for the whole module: the selection table renders it per row.
const cop = new Intl.NumberFormat("es-CO", {
  style: "currency",
  currency: "COP",
  maximumFractionDigits: 0,
});

export const formatCop = (amount: number): string => cop.format(amount);

// Estado según fecha of a batch, as the server decided it.
export const enrollmentStatusLabel = (
  status: Quote["enrollmentStatus"]
): string => (status === "enrolled" ? "Ingresado" : "Preingresado");

export const rateFor = (
  row: { rateWithVat: number; rateWithoutVat: number },
  withVat: boolean
): number => (withVat ? row.rateWithVat : row.rateWithoutVat);

export const vatLabel = (withVat: boolean): string =>
  withVat ? "con IVA" : "sin IVA";
